import { Container, Row, Col } from 'react-bootstrap';
import { Link } from 'react-router-dom';
import { useMobile } from '../../hooks/mediaHooks';

const AlphabetPage = ({ data, selectedLetter, setSelectedLetter, storeListTotal, isFirstPage, isLastPage, page, setPage }) => {
    const alphabet = 'ABCDEFGHIJKLMNOPQRSTUVWXYZ'.split('');

    const isMobile = useMobile();

    const letters = ['All', ...alphabet];
    const totalLetters = letters.length;
    const itemsPerRow = Math.ceil(totalLetters / 2); // ensure exactly 2 rows on mobile

    // Contoh data item
    const containerMobileStyle = isMobile ? { display: 'grid', gridTemplateColumns: `repeat(${itemsPerRow}, 1fr)`, gap: '8px 6px', alignItems: 'center' } : {};

    return (
        <Container className="mb-5">
            {/* Header */}
            {/* <div className="mb-4">
        <h2 className="fw-normal mb-1" style={{ fontSize: '24px' }}>Perlengkapan Rumah</h2>
      </div> */}

            {/* Navigasi Alfabet */}
            {/* flex-wrap and gap-12 on mobile */}
            <div className="alphabet-container mb-5" style={containerMobileStyle}>
                {letters.map((char) => {
                    const mobileStyle = isMobile ? { textAlign: 'center', padding: '4px 2px', fontSize: '0.72rem', display: 'block' } : {};

                    return (
                        <span
                            key={char}
                            className={`alphabet-link ${selectedLetter === char ? 'active' : ''}`}
                            onClick={() => {setSelectedLetter(char); setPage(0)}}
                            style={mobileStyle}
                        >
                            {char}
                        </span>
                    );
                })}
            </div>

            {/* Judul Huruf Aktif */}
            <h3 className="mb-5 fw-normal">{selectedLetter}</h3>

            {/* Grid Items (5 Kolom) */}
            <Row className="row-cols-1 row-cols-sm-2 row-cols-md-3 row-cols-lg-5 g-4 mt-2">
                {data?.length === 0 && <span className="text-gray-900">No Store Found</span>}
                {data?.map((item) => (
                    <Col key={item.id} as={Link} to={`/seller-store?storeid=${item.id}`} className="text-decoration-none">
                        <div className="text-center">
                            <div className="brand-card">
                                <img src={item.logo ? item.logo + '?width=110' : '/assets/images/no-image.png'} alt={item.name} />
                            </div>
                            <p className="mt-2 fw-medium text-dark">{item.businessName}</p>
                        </div>
                    </Col>
                ))}
            </Row>
            <ul className="pagination flex-center flex-wrap gap-16">
                {storeListTotal > 20 && !isFirstPage && (
                    <li className="page-item">
                        <Link
                            className="page-link h-64 w-64 flex-center text-xxl rounded-8 fw-medium text-neutral-600 border border-gray-100"
                            to="#"
                            onClick={() => setPage(page > 0 ? page - 1 : 0)}
                        >
                            <i className="ph-bold ph-arrow-left" />
                        </Link>
                    </li>
                )}
                {Array.from({ length: Math.ceil(storeListTotal / 20) }, (_, i) => (
                    <li className={`page-item ${page === i ? 'active' : ''}`} key={i}>
                        <Link
                            className={`page-link h-64 w-64 flex-center text-md rounded-8 fw-medium text-neutral-600 border border-gray-100 `}
                            to="#"
                            onClick={() => setPage(i)}
                        >
                            {String(i + 1).padStart(2, '0')}
                        </Link>
                    </li>
                ))}

                {storeListTotal > 20 && !isLastPage && (
                    <li className="page-item">
                        <Link
                            className="page-link h-64 w-64 flex-center text-xxl rounded-8 fw-medium text-neutral-600 border border-gray-100"
                            to="#"
                            onClick={() => setPage(page + 1)}
                        >
                            <i className="ph-bold ph-arrow-right" />
                        </Link>
                    </li>
                )}
            </ul>
        </Container>
    );
};

export default AlphabetPage;
